module.exports = __webpack_public_path__ + "static/media/twitter.1a7ca2da.svg";